module.exports = __webpack_public_path__ + "img/SL-M-240-320.60c8c5ee.svg";